document.addEventListener("DOMContentLoaded", () => {

    let searchDrawer = document.querySelector('.thb-cart-form');
    if (searchDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(searchDrawer, {
            childList: true
        });
    }

    const isPDP = window.location.pathname.includes("/products/");
    if (isPDP) {
        let oldHref = location.href;
        new MutationObserver(() => {
            if (oldHref !== location.href) {
                oldHref = location.href;
                const variant = new URL(location.href).searchParams.get('variant');
                let a = document.querySelector('.product-price-container')
                if (a) {
                    a.style.visibility = 'hidden';
                }
                setTimeout(() => {
                     if (a) {
                    a.style.visibility = 'visible';
                     }
                    const productForm = document.querySelector("[bss-b2b-main-product-form]");
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                        productForm
                    });
                }, 1000)
            }
        }).observe(document, {
            subtree: true,
            childList: true
        });
    }
});